import React from "react"
import { Box, componentStyles } from "@mallardbay/lib-react-components"

import { ListingType } from "~graphql/generated/graphql"
import { useIsMobile } from "~components/shared/todo-lib-react-components/hooks/use-is-mobile"
import COPY from "~config/copy-constants"
import { TextXLargeBold } from "~components/shared/todo-lib-react-components/text"
import { getCleanEnum } from "~utils/helpers"

import FilterCheckbox from "./filter-checkbox"
import { useSharedStyles } from "./use-shared-styles"

interface Props {
    readonly type: ListingType | undefined
    readonly setType: (type: ListingType | undefined) => void
}

export default function TypeSelector({ type, setType }: Props) {
    const styles = useStyles()
    const sharedStyles = useSharedStyles({ shouldAddBottomPadding: true })
    const options = useOptions()

    return (
        <Box style={sharedStyles.wrapper}>
            <TextXLargeBold>{COPY.LISTING_TYPE}</TextXLargeBold>
            <Box style={styles.checkboxWrapper}>
                {options.map(({ listingType, helpText }) => (
                    <FilterCheckbox
                        key={listingType}
                        label={getCleanEnum(listingType)}
                        isChecked={type === listingType}
                        onChange={(isSelected: boolean) =>
                            setType(isSelected ? listingType : undefined)
                        }
                        helpText={helpText}
                    />
                ))}
            </Box>
        </Box>
    )
}

function useStyles() {
    const isMobile = useIsMobile()

    return componentStyles({
        checkboxWrapper: {
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            columnGap: isMobile ? "10px" : "50px",
            flexWrap: "wrap",
        },
    })
}

function useOptions() {
    return [
        { listingType: ListingType.Hunting, helpText: COPY.EXPLORE_HUNTING },
        { listingType: ListingType.Fishing, helpText: COPY.EXPLORE_FISHING },
        {
            listingType: ListingType.BlastCast,
            helpText: COPY.EXPLORE_BLAST_CAST,
        },
        {
            listingType: ListingType.LodgingOnly,
            helpText: COPY.EXPLORE_LODGING,
        },
    ]
}
